import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed') as any;

export type FigureAlign = 'left' | 'center' | 'right' | '';

export interface FigureValue {
    src: string;
    width?: string;
    caption?: string;
    align?: FigureAlign;
}

class FigureBlot extends BlockEmbed {
    static blotName = 'image';
    static tagName = 'figure';

    static create(value: string | FigureValue) {
        const node = super.create() as HTMLElement;
        const src = typeof value === 'string' ? value : value.src;
        const width = typeof value === 'string' ? '' : (value.width || '');
        const caption = typeof value === 'string' ? '' : (value.caption || '');
        const align = typeof value === 'string' ? '' : (value.align || '');

        const classes = ['content-image'];
        if (align) classes.push(`align-${align}`);
        node.className = classes.join(' ');

        const img = document.createElement('img');
        img.setAttribute('src', src);
        if (width) img.setAttribute('width', width);
        node.appendChild(img);

        const figcaption = document.createElement('figcaption');
        figcaption.textContent = caption;
        node.appendChild(figcaption);

        return node;
    }

    static value(node: HTMLElement): FigureValue {
        const img = node.querySelector('img');
        const figcaption = node.querySelector('figcaption');
        const alignClass = Array.from(node.classList).find(c => c.startsWith('align-'));
        return {
            src: img?.getAttribute('src') || '',
            width: img?.getAttribute('width') || '',
            caption: figcaption?.textContent || '',
            align: (alignClass?.replace('align-', '') || '') as FigureAlign,
        };
    }
}

if ((Quill as any).imports['formats/image'] !== FigureBlot) {
    Quill.register({ 'formats/image': FigureBlot }, true);
}

export { FigureBlot };
